var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.75H14C19.43 21.75 21.75 19.43 21.75 14V8C21.75 2.57 19.43 0.25 14 0.25H8C2.57 0.25 0.25 2.57 0.25 8V14C0.25 19.43 2.57 21.75 8 21.75ZM14 1.75C18.61 1.75 20.25 3.39 20.25 8V14C20.25 18.61 18.61 20.25 14 20.25H8C3.39 20.25 1.75 18.61 1.75 14V8C1.75 3.39 3.39 1.75 8 1.75H14Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2598 15.28C12.4498 15.28 12.6398 15.21 12.7898 15.06C13.0798 14.77 13.0798 14.29 12.7898 14L9.78982 11L12.7898 7.99997C13.0798 7.70997 13.0798 7.22997 12.7898 6.93997C12.4998 6.64997 12.0198 6.64997 11.7298 6.93997L8.19982 10.47C7.90982 10.76 7.90982 11.24 8.19982 11.53L11.7298 15.06C11.8798 15.21 12.0698 15.28 12.2598 15.28Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.51e79ec6006dfbeda5b4502adbdd7837.svg";
export { ForwardRef as ReactComponent };